import moment from "moment";

export class Score {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Score";
    this.scene = "Score Update";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.options = options;
    this.data = [];
    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
          ] || "",
      },
    });

    switch (options.type) {
      case "ABANDONED":
        this.data.push({
          name: "Half Text",
          value: { text: "Match Abandoned" },
        });
        if (options.highlights) {
          this.scene = "FT Score Highlights";
        }
        break;
      case "HT":
        this.scene = "HT Score";

        this.data.push({
          name: "Half Text",
          value: { text: "Half Time" },
        });
        break;
      case "FT":
        this.data.push({
          name: "Half Text",
          value: { text: "Full Time" },
        });
        let ft_caption = "";
        this.scene = "FT Score";
        if (options.highlights) {
          this.scene = "FT Score Highlights";
        }
        if (options.game.leg === 2) {
          let home_agg_score =
            options.game.agg_home_score +
            (options.game.home_scorers?.length || 0);
          let away_agg_score =
            options.game.agg_away_score +
            (options.game.away_scorers?.length || 0);
          if (home_agg_score > away_agg_score) {
            ft_caption =
              options.game?.home_team?.name +
              " win " +
              home_agg_score +
              "-" +
              away_agg_score +
              " on aggregate";
          } else if (away_agg_score > home_agg_score) {
            ft_caption =
              options.game?.away_team?.name +
              " win " +
              away_agg_score +
              "-" +
              home_agg_score +
              " on aggregate";
          } else {
            ft_caption =
              home_agg_score + "-" + away_agg_score + " on aggregate";
          }
        }
        this.data.push({
          name: "Score Caption",
          value: { text: ft_caption },
        });

        break;
      case "ETHT":
        this.data.push({
          name: "Half Text",
          value: { text: "ET Half Time" },
        });
        let etht_caption = "";
        this.scene = "ET HT Score";
        if (options.game.leg === 2) {
          let home_agg_score =
            options.game.agg_home_score +
            (options.game.home_scorers?.length || 0);
          let away_agg_score =
            options.game.agg_away_score +
            (options.game.away_scorers?.length || 0);

          etht_caption =
            home_agg_score + "-" + away_agg_score + " on aggregate";
        }
        this.data.push({
          name: "Score Caption",
          value: { text: etht_caption },
        });
        break;
      case "ETFT":
        this.data.push({
          name: "Half Text",
          value: { text: "AET" },
        });
        let caption = "";
        let home_score_et = options.game?.home_scorers.length || 0;
        let away_score_et = options.game?.away_scorers.length || 0;
        if (options.game.leg === 2) {
          home_score_et += options.game.agg_home_score;
          away_score_et += options.game.agg_away_score;
        }
        if (home_score_et > away_score_et) {
          caption =
            options.game?.home_team?.name +
            " win " +
            home_score_et +
            "-" +
            away_score_et +
            " AET";
        } else if (away_score_et > home_score_et) {
          caption =
            options.game?.away_team?.name +
            " win " +
            away_score_et +
            "-" +
            home_score_et +
            " AET";
        } else {
          caption = home_score_et + "-" + away_score_et + " AET";
        }

        this.data.push({
          name: "Score Caption",
          value: { text: caption },
        });
        this.scene = "ET FT Score";

        break;
      case "PENS":
        this.data.push({
          name: "Half Text",
          value: { text: "Penalties" },
        });
        let penalty_caption = "";
        let home_penalties =
          options.game?.home_penalties?.filter((goal) => goal.type > 0)
            .length || 0;
        let away_penalties =
          options.game?.away_penalties?.filter((goal) => goal.type > 0)
            .length || 0;
        if (home_penalties > away_penalties) {
          penalty_caption =
            options.game?.home_team?.name +
            " win " +
            home_penalties +
            "-" +
            away_penalties +
            " on penalties";
        } else if (away_penalties > home_penalties) {
          penalty_caption =
            options.game?.away_team?.name +
            " win " +
            away_penalties +
            "-" +
            home_penalties +
            " on penalties";
        }

        this.scene = "Penalties Score";

        if (options.highlights) {
          this.scene = "FT Score Highlights";
        }
        this.data.push({
          name: "Score Caption",
          value: { text: penalty_caption },
        });
        break;
      default:
        this.scene = "Score Update";
    }

    this.data.push({
      name: "Period",
      value: {
        text: options.period
          ? options.period?.kick_off === null
            ? options.period.number - 1
            : options.period.number
          : "",
      },
    });

    this.data.push({
      name: "Group",
      value: {
        text: options.group?.title || "",
      },
    });

    this.data.push({
      name: "Stadium",
      value: {
        text:
          options.game?.stadium?.name || options.game?.stadium?.opta_name || "",
      },
    });
    this.data.push({
      name: "Home Team Name",
      value: { text: options.game?.home_team?.name || "" },
    });
    this.data.push({
      name: "Home Team Short Name",
      value: { text: options.game?.home_team?.short_name || "" },
    });

    this.data.push({
      name: "Away Team Name",
      value: { text: options.game?.away_team?.name || "" },
    });

    this.data.push({
      name: "Away Team Short Name",
      value: { text: options.game?.away_team?.short_name || "" },
    });

    this.data.push({
      name: "Home Team Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.alt_badge,
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.alt_badge,
      },
    });
    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Score",
      value: {
        text: options.game?.home_scorers?.length || 0,
      },
    });
    this.data.push({
      name: "Away Score",
      value: {
        text: options.game?.away_scorers?.length || 0,
      },
    });
    this.data.push({
      name: "ET Home Score",
      value: {
        text:
          options.game?.home_scorers?.filter((goal) => goal.period > 2)
            .length || 0,
      },
    });
    this.data.push({
      name: "ET Away Score",
      value: {
        text:
          options.game?.away_scorers?.filter((goal) => goal.period > 2)
            .length || 0,
      },
    });
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    let scorer;
    let scorers_sorted = [
      ...(options.game?.home_scorers?.map((s) => {
        return { ...s, team: "home" };
      }) || []),
      ...(options.game?.away_scorers?.map((s) => {
        return { ...s, team: "away" };
      }) || []),
    ];

    scorers_sorted = scorers_sorted.sort((a, b) => b.time - a.time);
    if (scorers_sorted.length > 0) {
      scorer = scorers_sorted[0];
    }

    for (let i = 1; i <= 10; i++) {
      let scorer = scorers_sorted?.filter((s) => s.team === "home")?.[i - 1];
      let scorer_player = options.game.lineup?.home?.find(
        (l) => l.squad?._id === scorer?.player
      );
      if (!scorer_player) {
        scorer_player = options.game.lineup?.away?.find(
          (l) => l.squad?._id === scorer?.player
        );
      }

      this.data.push({
        name: "Home Scorer " + i + " Shirt Number",
        value: {
          text:
            scorer_player?.squad?.shirt_number ??
            scorer_player?.squad?.opta_shirt_number ??
            "",
        },
      });

      this.data.push({
        name: "Home Scorer " + i + " First Name Uppercase",
        value: {
          text:
            scorer_player?.squad?.player?.first_name_upper ??
            scorer_player?.squad?.player?.opta_first_name?.toUpperCase() ??
            "",
        },
      });

      this.data.push({
        name: "Home Scorer " + i + " Last Name Uppercase",
        value: {
          text:
            scorer_player?.squad?.player?.last_name_upper ??
            scorer_player?.squad?.player?.opta_last_name?.toUpperCase() ??
            "",
        },
      });

      let time = moment.duration(scorer?.time);
      let minutes = time?.minutes() + time?.hours() * 60;
      let goalTime = "";
      // minutes += 1;
      if (
        scorer?.period === 2 &&
        minutes > (options?.game?.config?.half_duration || 45) * 2
      ) {
        goalTime =
          (options?.game?.config?.half_duration || 45) * 2 +
          "'+" +
          (minutes - (options?.game?.config?.half_duration || 45) * 2);
      } else if (
        scorer?.period === 1 &&
        minutes > (options?.game?.config?.half_duration || 45)
      ) {
        goalTime =
          (options?.game?.config?.half_duration || 45) +
          "'+" +
          (minutes - (options?.game?.config?.half_duration || 45));
      } else {
        goalTime = minutes + "'";
      }
      this.data.push({
        name: "Home Scorer " + i + " Goal Time",
        value: { text: (scorer && goalTime) || "" },
      });

      scorer = scorers_sorted?.filter((s) => s.team === "away")?.[i - 1];
      scorer_player = options.game.lineup?.home?.find(
        (l) => l.squad?._id === scorer?.player
      );
      if (!scorer_player) {
        scorer_player = options.game.lineup?.away?.find(
          (l) => l.squad?._id === scorer?.player
        );
      }

      this.data.push({
        name: "Away Scorer " + i + " Shirt Number",
        value: {
          text:
            scorer_player?.squad?.shirt_number ??
            scorer_player?.squad?.opta_shirt_number ??
            "",
        },
      });

      this.data.push({
        name: "Away Scorer " + i + " First Name Uppercase",
        value: {
          text:
            scorer_player?.squad?.player?.first_name_upper ??
            scorer_player?.squad?.player?.opta_first_name?.toUpperCase() ??
            "",
        },
      });

      this.data.push({
        name: "Away Scorer " + i + " Last Name Uppercase",
        value: {
          text:
            scorer_player?.squad?.player?.last_name_upper ??
            scorer_player?.squad?.player?.opta_last_name?.toUpperCase() ??
            "",
        },
      });

      time = moment.duration(scorer?.time);
      minutes = time?.minutes() + time?.hours() * 60;
      goalTime = "";
      // minutes += 1;
      if (
        scorer?.period === 2 &&
        minutes > (options?.game?.config?.half_duration || 45) * 2
      ) {
        goalTime =
          (options?.game?.config?.half_duration || 45) * 2 +
          "'+" +
          (minutes - (options?.game?.config?.half_duration || 45) * 2);
      } else if (
        scorer?.period === 1 &&
        minutes > (options?.game?.config?.half_duration || 45)
      ) {
        goalTime =
          (options?.game?.config?.half_duration || 45) +
          "'+" +
          (minutes - (options?.game?.config?.half_duration || 45));
      } else {
        goalTime = minutes + "'";
      }
      this.data.push({
        name: "Away Scorer " + i + " Goal Time",
        value: { text: (scorer && goalTime) || "" },
      });
    }

    let scorer_player = options.game.lineup?.home?.find(
      (l) => l.squad?._id === scorer?.player
    );
    if (!scorer_player) {
      scorer_player = options.game.lineup?.away?.find(
        (l) => l.squad?._id === scorer?.player
      );
    }

    if (options.no_scorers) {
      scorer_player = null;
      scorer = null;
    }
    this.data.push({
      name: "Last Goal Player First Name Uppercase",
      value: {
        text:
          scorer_player?.squad?.player?.first_name_upper ??
          scorer_player?.squad?.player?.opta_first_name?.toUpperCase() ??
          "",
      },
    });

    this.data.push({
      name: "Last Goal Player Last Name Uppercase",
      value: {
        text:
          scorer_player?.squad?.player?.last_name_upper ??
          scorer_player?.squad?.player?.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Goal Player Full Name",
      value: {
        text:
          (scorer_player?.squad?.player?.first_name ??
            scorer_player?.squad?.player.opta_first_name ??
            "") +
          " " +
          (scorer_player?.squad?.player?.last_name ??
            scorer_player?.squad?.player.opta_last_name ??
            ""),
      },
    });

    this.data.push({
      name: "Last Goal Player Full Name Uppercase",
      value: {
        text:
          (scorer_player?.squad?.player?.first_name_upper ??
            scorer_player?.squad?.player.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (scorer_player?.squad?.player?.last_name_upper ??
            scorer_player?.squad?.player.opta_last_name?.toUpperCase() ??
            ""),
      },
    });
    this.data.push({
      name: "Last Goal Team",
      value: { text: scorer?.team || "" },
    });

    this.data.push({
      name: "Last Goal Penalty",
      value: { text: scorer?.penalty || "" },
    });
    this.data.push({
      name: "Last Goal OG",
      value: { text: scorer?.own_goal || "" },
    });

    let time = moment.duration(scorer?.time);
    let minutes = time?.minutes() + time?.hours() * 60;
    let goalTime = "";
    // minutes += 1;
    if (
      scorer?.period === 2 &&
      minutes > (options?.game?.config?.half_duration || 45) * 2
    ) {
      goalTime =
        (options?.game?.config?.half_duration || 45) * 2 +
        "'+" +
        (minutes - (options?.game?.config?.half_duration || 45) * 2);
    } else if (
      scorer?.period === 1 &&
      minutes > (options?.game?.config?.half_duration || 45)
    ) {
      goalTime =
        (options?.game?.config?.half_duration || 45) +
        "'+" +
        (minutes - (options?.game?.config?.half_duration || 45));
    } else {
      goalTime = minutes + "'";
    }
    if (options.no_scorers) {
      goalTime = "";
    }
    this.data.push({
      name: "Last Goal Time",
      value: { text: goalTime || "" },
    });

    let period = [...(options.game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number
    )[0];

    let clock = period.kick_off;

    if (period.number === 2) {
      clock -= 1000 * 60 * (options?.game?.config?.half_duration || 45);
    }
    if (period.number === 3) {
      clock -= 1000 * 60 * ((options?.game?.config?.half_duration || 45) * 2);
    }
    if (period.number === 4) {
      clock -= 1000 * 60 * 105;
    }

    this.data.push({
      name: "Game Clock",
      value: {
        action: "start",
        time: moment().valueOf() - clock,
      },
    });

    // let scorer;

    // if (options.show_scorers) {
    //   let scorers_sorted = [
    //     ...options.game.live_data.home_scorers.map((s) => {
    //       return { ...s, team: "home" };
    //     }),
    //     ...options.game.live_data.away_scorers.map((s) => {
    //       return { ...s, team: "away" };
    //     }),
    //   ];

    //   scorers_sorted = scorers_sorted.sort((a, b) => b.time - a.time);
    //   if (scorers_sorted.length > 0) {
    //     scorer = scorers_sorted[0];
    //   }
    // }
    // debugger;
    // this.data = [
    //   {
    //     name: "TopTEXT",
    //     value: { text: options.game.competition.name.toUpperCase() },
    //   },
    //   {
    //     name: "Home Team",
    //     value: { text: options.game.home_team.variables["name_uppercase"] },
    //   },
    //   {
    //     name: "Away Team",
    //     value: { text: options.game.away_team.variables["name_uppercase"] },
    //   },
    //   { name: "STADIUM_TEXT", value: { text: options.game.stadium.name } },
    //   options.game.home_team.variables["badge_home"] && {
    //     name: "Home Badge IMG",
    //     value: {
    //       image:
    //         "http://localhost:6060/uploads/MAN CITY/" +
    //         window.encodeURIComponent(
    //           "Badges/" + options.game.home_team.variables["badge_home"]
    //         ),
    //     },
    //   },
    //   options.game.away_team.variables["badge_away"] && {
    //     name: "Away Badge IMG",
    //     value: {
    //       image:
    //         "http://localhost:6060/uploads/MAN CITY/" +
    //         window.encodeURIComponent(
    //           "Badges/" + options.game.away_team.variables["badge_away"]
    //         ),
    //     },
    //   },
    //   {
    //     name: "Home Score",
    //     value: {
    //       text:
    //         (options.game.live_data &&
    //           options.game.live_data.home_team_score) ||
    //         0,
    //     },
    //   },
    //   {
    //     name: "Away Score",
    //     value: {
    //       text:
    //         (options.game.live_data &&
    //           options.game.live_data.away_team_score) ||
    //         0,
    //     },
    //   },
    //   {
    //     name: "VENUE",
    //     value: { text: options.game?.stadium?.name || "" },
    //   },
    //   {
    //     name: "COMMENTATORS",
    //     value: { text: options.game?.commentators || "" },
    //   },
    //   { name: "HALF_TIME", value: { visible: true } },
    //   {
    //     name: "HOME_SCORE_GRP",
    //     value: {
    //       visible:
    //         options.show_scorers && scorer && scorer.team === "home"
    //           ? true
    //           : false,
    //     },
    //   },
    //   {
    //     name: "AWAY_SCORE_GRP",
    //     value: {
    //       visible:
    //         options.show_scorers && scorer && scorer.team === "away"
    //           ? true
    //           : false,
    //     },
    //   },
    // ];

    // if (options.show_scorers && scorer) {
    //   let player = options.game.live_data.home_team_lineup.find(
    //     (l) => l._id === scorer.player
    //   );
    //   if (!player) {
    //     player = options.game.live_data.away_team_lineup.find(
    //       (l) => l._id === scorer.player
    //     );
    //   }
    //   let time = moment.duration(scorer.time);
    //   this.data.push({
    //     name: scorer.team.toUpperCase() + "_SCORER",
    //     value: {
    //       text:
    //         player.first_name[0] +
    //         ". " +
    //         player.last_name +
    //         " " +
    //         (time.minutes() + time.hours() * 60) +
    //         "' " +
    //         (scorer.type ? scorer.type : ""),
    //     },
    //   });
    // }
    if (window.ENV?.REACT_APP_IMG || process.env.REACT_APP_IMG) {
      if (!options.highlights && !options.no_scorers) {
        let home_scorers = options?.game?.dfb_ID
          ? this.buildDFBGoalScorers({
              game: options.game,
              team: options?.game?.home_team,
              events: options?.dfbEvents?.filter((item) => {
                try {
                  return item.type === "Goal";
                } catch (e) {
                  return false;
                }
              }),
            })
          : this.buildGoalScorers({
              game: options.game,
              team: options?.game?.home_team,
              events: options?.optaEvents?.filter((item) => {
                try {
                  return item.typeId === 16;
                } catch (e) {
                  return false;
                }
              }),
            });

        this.data.push({
          name: "Home Scorers Line 1",
          value: {
            text: options.no_scorers ? "" : home_scorers?.[0] ?? "",
          },
        });
        this.data.push({
          name: "Home Scorers Line 2",
          value: {
            text: options.no_scorers ? "" : home_scorers?.[1] ?? "",
          },
        });

        this.data.push({
          name: "Home Scorers Line 3",
          value: {
            text: options.no_scorers ? "" : home_scorers?.[2] ?? "",
          },
        });
        let away_scorers = options?.game?.dfb_ID
          ? this.buildDFBGoalScorers({
              game: options.game,
              team: options?.game?.away_team,
              events: options?.dfbEvents?.filter((item) => {
                try {
                  return item.type === "Goal";
                } catch (e) {
                  return false;
                }
              }),
            })
          : this.buildGoalScorers({
              game: options.game,
              team: options?.game?.away_team,
              events: options?.optaEvents?.filter((item) => {
                try {
                  return item.typeId === 16;
                } catch (e) {
                  return false;
                }
              }),
            });

        this.data.push({
          name: "Away Scorers Line 1",
          value: {
            text: options.no_scorers ? "" : away_scorers?.[0] ?? "",
          },
        });
        this.data.push({
          name: "Away Scorers Line 2",
          value: {
            text: options.no_scorers ? "" : away_scorers?.[1] ?? "",
          },
        });

        this.data.push({
          name: "Away Scorers Line 3",
          value: {
            text: options.no_scorers ? "" : away_scorers?.[2] ?? "",
          },
        });
      } else {
        this.data.push({
          name: "Home Scorers Line 1",
          value: {
            text: "",
          },
        });
        this.data.push({
          name: "Home Scorers Line 2",
          value: {
            text: "",
          },
        });

        this.data.push({
          name: "Home Scorers Line 3",
          value: {
            text: "",
          },
        });
        this.data.push({
          name: "Away Scorers Line 1",
          value: {
            text: "",
          },
        });
        this.data.push({
          name: "Away Scorers Line 2",
          value: {
            text: "",
          },
        });

        this.data.push({
          name: "Away Scorers Line 3",
          value: {
            text: "",
          },
        });
      }
    }
    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  groupBy = (key) => (array) =>
    array.reduce((objectsByKeyValue, obj) => {
      const value = obj[key];
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});

  buildGoalScorers({ game, events, team }) {
    let goalRows = [""];
    let goals = {};
    if (events && events?.length > 0) {
      goals = this.groupBy("playerId")(
        events.filter((item) => {
          let ownGoal = false;
          if (item.qualifier.find((q) => q.qualifierId === 28) !== undefined) {
            ownGoal = true;
          }
          let output = false;
          if (ownGoal && item.contestantId !== team?.opta_ID) {
            output = true;
          }
          if (ownGoal === false && item.contestantId === team?.opta_ID) {
            output = true;
          }

          return output;
        })
      );
    }
    goals = Object.keys(goals).map((key) => {
      let player = game?.lineup?.home?.find(
        (p) => p?.squad?.player?.opta_ID === goals[key][0].playerId
      );
      if (player === undefined) {
        player = game?.lineup?.away?.find(
          (p) => p?.squad?.player?.opta_ID === goals[key][0].playerId
        );
      }
      let output =
        player.squad?.player?.last_name ?? player.squad?.player?.opta_last_name;
      goals[key].map((item, index) => {
        if (index === 0) {
          output += " (";
        }

        if (item.periodId === 1 && item.timeMin >= 45) {
          output += "45'+" + parseInt(item.timeMin - 45 + 1);
        } else if (item.periodId === 2 && item.timeMin >= 90) {
          output += "90'+" + parseInt(item.timeMin - 90 + 1);
        } else {
          output += item.timeMin + 1;
          output += "'";
        }

        if (item.qualifier.find((q) => q.qualifierId === 9) !== undefined) {
          output += " P";
        }
        if (item.qualifier.find((q) => q.qualifierId === 28) !== undefined) {
          output += " OG";
        }
        if (index === goals[key].length - 1) {
          output += ")";
        } else {
          output += ", ";
        }
      });
      return output;
    });

    let row = 0;

    goals.map((x) => {
      if ((goalRows[row] + x).length < 30 || row === 2) {
        goalRows[row] += (goalRows[row].length > 0 ? ", " : "") + x;
      } else {
        row += 1;
        goalRows.push(x);
      }
    });
    return goalRows;
  }

  buildDFBGoalScorers({ game, events, team }) {
    let goalRows = [""];
    let goals = {};
    if (events && events?.length > 0) {
      goals = this.groupBy("playerId")(
        events.filter((item) => {
          let ownGoal =
            item.own_goal ||
            item.qualifier?.find((q) => q.qualifierId === 28) !== undefined;
          let output = false;
          if (ownGoal && item.contestantId !== team?.dfb_ID) {
            output = true;
          }
          if (ownGoal === false && item.contestantId === team?.dfb_ID) {
            output = true;
          }

          return output;
        })
      );
    }
    goals = Object.keys(goals).map((key) => {
      let player = game?.lineup?.home?.find(
        (p) => p?.squad?.player?.dfb_ID === goals[key][0].playerId
      );
      if (player === undefined) {
        player = game?.lineup?.away?.find(
          (p) => p?.squad?.player?.dfb_ID === goals[key][0].playerId
        );
      }
      let output =
        player?.squad?.player?.last_name ??
        player?.squad?.player?.opta_last_name;
      goals[key].map((item, index) => {
        if (index === 0) {
          output += " (";
        }

           if (item.period === 1 && item.timeMin >= 45) {
          output += "45'+" + parseInt(item.timeMin - 45 + 1);
        } else if (item.period === 2 && item.timeMin >= 90) {
          output += "90'+" + parseInt(item.timeMin - 90 + 1);
        } else {
          output += item.timeMin + 1;
          output += "'";
        }

        if (
          item.penalty ||
          item.qualifier?.find((q) => q.qualifierId === 9) !== undefined
        ) {
          output += " P";
        }
        if (
          item.own_goal ||
          item.qualifier?.find((q) => q.qualifierId === 28) !== undefined
        ) {
          output += " OG";
        }
        if (index === goals[key].length - 1) {
          output += ")";
        } else {
          output += ", ";
        }
      });
      return output;
    });

    let row = 0;

    goals.map((x) => {
      if ((goalRows[row] + x).length < 30 || row === 2) {
        goalRows[row] += (goalRows[row].length > 0 ? ", " : "") + x;
      } else {
        row += 1;
        goalRows.push(x);
      }
    });
    return goalRows;
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
